import { styled, css, useTheme } from '@vebox/etui-system';
import { mediaMax } from '../utilities/responsive.js';
import { createElement, Fragment } from 'react';
import { a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import { fade } from '@vebox/etui-colors';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader.js';

var BigValueDiv = styled(Div).attrs(props => _objectSpread2({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: props.justifyContent || 'center'
}, props))`
  line-height: 1.5;
`;

var ValueSpan = styled(Span)`
  font-weight: bold;
  word-break: normal;
  ${({
  warning,
  small,
  medium,
  theme
}) => css`
    line-height: ${small ? 1.5 : 1};
    font-size: ${() => {
  if (small) return 'calc(2em * 1.2 * 1.2);';
  if (medium) return 'calc(2em * 1.3 * 1.3);';
  return 'calc(2em * 1.2 * 1.2 * 1.2 * 1.2 * 1.2 * 1.2);';
}};
    color: ${warning ? theme.palette.error.main : theme.palette.text.primary};
    text-shadow: 2px 2px 0
      ${fade(warning ? theme.palette.error.main : theme.palette.text.primary, 0.1)};

    ${mediaMax(theme).xs`
      font-size: ${small ? 'calc(1.5em * 1.3 * 1.3);' : 'calc(1.5em * 1.2 * 1.2 * 1.2 * 1.2 * 1.2 * 1.2)'};
    `};
  `}
`;

var SuffixContent = styled(Span)`
  font-size: calc(1em * 1.2 * 1.2);
  margin-left: ${({
  theme
}) => theme === null || theme === void 0 ? void 0 : theme.spacing.xxs}px;
  word-break: normal;
`;

const BigValue = ({
  testId,
  loading = false,
  value,
  warning,
  suffix,
  small,
  medium,
  styles = {}
}) => {
  const theme = useTheme();
  const largeSkeletonSize = 'calc(2em * 1.2 * 1.2 * 1.2 * 1.2 * 1.2 * 1.2)';
  const largeSkeletonMobileSize = 'calc(1.5em * 1.2 * 1.2 * 1.2 * 1.2 * 1.2 * 1.2)';
  const mediumSkeletonSize = 'calc(2em * 1.2 * 1.2 * 1.2)';
  const mediumSkeletonMobileSize = 'calc(1.5em * 1.2 * 1.2 * 1.2 * 1.2 * 1.2)';
  return /*#__PURE__*/createElement(BigValueDiv, styles.root, loading ? /*#__PURE__*/createElement(SkeletonLoader, {
    height: {
      xs: `calc(
              ${medium ? mediumSkeletonMobileSize : largeSkeletonMobileSize} - ${theme.spacing.sm}px
            )`,
      sm: `calc(
              ${medium ? mediumSkeletonSize : largeSkeletonSize} - ${theme.spacing.sm}px
            )`
    },
    borderRadius: "5%",
    width: {
      xs: '45px',
      sm: '55px'
    },
    mt: `${theme.spacing.sm}px`,
    testId: "bigValueSkeletonLoader"
  }) : /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(ValueSpan, _extends({
    warning: warning,
    small: small,
    medium: medium,
    theme: theme
  }, styles.bigValue, {
    testId: testId
  }), value), suffix && /*#__PURE__*/createElement(SuffixContent, styles.suffix, suffix)));
};

export { BigValue };
